module.exports = __webpack_public_path__ + "31bb2de598db541cf06aff9c1308c4a1.svg";